var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRumble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2200,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "46.403999999999996 -58.75600000000003 2416.682 2528.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M828.619 1296.917c2.834-110.609 11.832-195.681 43.279-277.043 44.786-115.875 108.106-154.569 229.739-128.669 159.489 33.971 297.452 110.766 412.572 226.973 12.497 12.635 23.155 27.355 33.286 42.055 49.775 72.315 53.134 123.475-.909 191.272-119.289 149.617-271.232 254.223-457.13 302.981-110.799 29.066-177.198-10.134-217.435-118.447-11.778-31.733-22.437-64.547-27.948-97.816-9.067-54.64-17.746-109.715-15.454-141.306z",
    stroke: "#fff",
    strokeWidth: 50
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M606.722 213.176s-229.511-.542-329.231 167.872c0 0-68.239 96.447-113.39 276.428 0 0-117.697 615.048-49.179 1075.888 0 0 17.361 396.522 271.46 511.699 0 0 152.523 91.405 487.214-37.681 0 0 548.592-188.837 807.712-488.723 0 0-442.113 287.282-672.026 290.064 0 0-337.282 88.504-411.733-178.897 0 0-179.438-453.313-123.679-1168.657.001 0 3.764-152.33 132.852-447.993z",
    stroke: "#EF8E6D",
    strokeWidth: 50
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2345.707 1325.797s117.379-197.242 23.238-368.856c0 0-48.248-107.844-180.141-238.403 0 0-469.342-414.531-900.818-590.277 0 0-350.076-187.017-578.606-26.988 0 0-156.354 84.671-215.754 438.439 0 0-116.889 568.299 9.206 944.015 0 0-22.052-526.786 92.652-726.038 0 0 95.644-335.34 363.674-263.235 0 0 481.494 76.479 1068.692 488.808.001-.001 129.194 80.82 317.857 342.535z",
    stroke: "#EF8E6D",
    strokeWidth: 50
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M569.34 2275.129s122.455 194.141 318.1 188.17c0 0 117.993 5.971 294.212-52.276 0 0 582.44-229.983 934.896-534.64 0 0 325.572-227.026 286.737-503.3 0 0-4.462-177.726-292.708-391.275 0 0-457.147-343.986-849.173-402.229 0 0 399.639 145.365 608.71 394.022 0 0 255.373 237.454 69.441 443.549 0 0-286.737 394.265-920.701 730.29.002 0-130.66 78.405-449.514 127.689z",
    stroke: "#EF8E6D",
    strokeWidth: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRumble);
export default __webpack_public_path__ + "static/media/rumble.a717e85eeb80527e70f1a8e867306360.svg";
export { ForwardRef as ReactComponent };